import { v4 as createGuid } from 'uuid';

import { uploadAttachmentToS3 } from 'src/context/upload-attachments/upload-attachment-to-s3';
import type { Zone } from 'src/types';

import type { Resume } from '../../__generated__/graphql.ts';

import { attachResumeToProfile } from './attach-resume-to-profile';

export interface UploadResumeResponse {
  resumeId: string;
  uri: string;
  resume: Resume;
}

interface UploadResumeArgs {
  resume: File;
  guid: string;
  zone: Zone;
}

export const uploadResume = async ({
  resume,
  guid,
  zone,
}: UploadResumeArgs): Promise<UploadResumeResponse> => {
  const resumeId = createGuid();

  return uploadAttachmentToS3({ attachmentId: resumeId, attachment: resume })
    .then(() => attachResumeToProfile({ resumeId, contextId: guid, zone }))
    .then(({ resume: resumeResult, uri }) => ({
      resumeId,
      uri,
      resume: resumeResult as Resume,
    }));
};
